import categoriesCount from './stats';

// Click the home btn to start stats count
setTimeout(() => {
    document.getElementById("home").click();
}, 1000);

// Cookies Pop-up
coockiePop();

function coockiePop() {
    setTimeout(function () {
        cookieTime();
    }, 8000);

    function cookieTime() {
        document.getElementById("cookiePop").classList.remove("d-none");
    }
}

// Firefox alert banner
if (navigator.userAgent.indexOf("Firefox") > 0) {
    document.getElementById("firefoxBanner").classList.remove("d-none");
}

window.removeBanner = function () {
    document.getElementById("firefoxBanner").classList.add("d-none");
};

// Scrolling Nav Marker
document.getElementById("main").addEventListener("scroll", scrollMarker);

let position = '';

function scrollMarker() {
    let cliked = document.getElementsByClassName("clicked");
    let clicked_arr = [...cliked];

    if (clicked_arr.length === 0) {
        let marker = document.querySelector("#marker");
        let scroll = getOffset(document.getElementById("main")).top;
        let wc = getOffset(document.getElementById("welcome-collapsible")).top;
        let pr = getOffset(document.getElementById("projects-collapsible")).top;
        let xp = getOffset(
            document.getElementById("work_experience-collapsible")
        ).top;
        let am = getOffset(document.getElementById("about_me-collapsible")).top;
        let co = getOffset(document.getElementById("contact-collapsible")).top;

        function getOffset(el) {
            let _x = 0;
            let _y = 0;
            while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                _x += el.offsetLeft - el.scrollLeft;
                _y += el.offsetTop + el.scrollTop;
                el = el.offsetParent;
            }
            return {
                top: _y,
                left: _x,
            };
        }

        function returnToActive() {
            let ele = document.getElementsByClassName("active");

            for (let i = 0; i < ele.length; i++) {
                let me = ele[i];
                marker.style.top = me.offsetTop + "px";
            }
        }

        if (scroll >= wc && scroll < pr - 600 && position !== 'home') {
            document.querySelector("#contact").classList.remove("active");
            document.querySelector("#projects").classList.remove("active");
            document
                .querySelector("#work_experience")
                .classList.remove("active");
            document.querySelector("#about_me").classList.remove("active");

            document.querySelector("#welcome").classList.add("active");
            categoriesCount('home');
            returnToActive();
            position = 'home';
        } else if (scroll >= pr - 600 && scroll < xp - 400 && position !== 'projects') {
            document.querySelector("#contact").classList.remove("active");
            document.querySelector("#welcome").classList.remove("active");
            document
                .querySelector("#work_experience")
                .classList.remove("active");
            document.querySelector("#about_me").classList.remove("active");

            document.querySelector("#projects").classList.add("active");
            categoriesCount('proj');
            returnToActive();
            position = 'projects';
        } else if (scroll >= xp - 400 && scroll < am - 400 && position !== 'exp') {
            document.querySelector("#contact").classList.remove("active");
            document.querySelector("#welcome").classList.remove("active");
            document.querySelector("#projects").classList.remove("active");
            document.querySelector("#about_me").classList.remove("active");

            document.querySelector("#work_experience").classList.add("active");
            categoriesCount('exp');
            returnToActive();
            position = 'exp';
        } else if (scroll >= am - 400 && scroll < co - 750 && position !== 'about') {
            document.querySelector("#contact").classList.remove("active");
            document.querySelector("#welcome").classList.remove("active");
            document.querySelector("#projects").classList.remove("active");
            document
                .querySelector("#work_experience")
                .classList.remove("active");

            document.querySelector("#about_me").classList.add("active");
            categoriesCount('about');
            returnToActive();
            position = 'about';
        } else if (scroll >= co - 750 && position !== 'contact') {
            document.querySelector("#welcome").classList.remove("active");
            document.querySelector("#projects").classList.remove("active");
            document
                .querySelector("#work_experience")
                .classList.remove("active");
            document.querySelector("#about_me").classList.remove("active");

            document.querySelector("#contact").classList.add("active");
            categoriesCount('cont');
            returnToActive();
            position = 'contact';
        }
    }
}

// Navigation Marker
function navMarker() {
    let marker = document.querySelector("#marker");
    // let listBoard = document.querySelector("#nav-glass");
    let list = document.querySelectorAll("#nav-glass li");

    // let timer;

    // listBoard.addEventListener("mouseleave", () => {
    //     returnToActive();
    // });

    // function returnToActive() {
    //     let ele = document.getElementsByClassName("active");

    //     for (let i = 0; i < ele.length; i++) {
    //         let me = ele[i];
    //         marker.style.top = me.offsetTop + "px";
    //     }
    // }

    function moveIndicator(e) {
        marker.style.top = e.offsetTop + "px";
        // clearTimeout(timer);
    }

    list.forEach((Link) => {
        Link.addEventListener("click", (e) => { //mousemove
            moveIndicator(e.target);
            categoriesCount(e.target.id);
        });
        // Link.addEventListener("mouseout", (e) => {
        //     timer = setTimeout(returnToActive, 3000);
        // });
    });

    function activeLink() {
        list.forEach((item) => item.classList.remove("active"));
        this.classList.add("active");
        this.classList.add("clicked");
        setTimeout(() => {
            this.classList.remove("clicked");
        }, 850);
    }

    addActiveLink();

    function addActiveLink() {
        list.forEach((item) => item.addEventListener("click", activeLink));
    }
}

// Loading Page Animation

window.addEventListener("load", reveal);

function reveal() {
    responsiveNav();
    let reveal = document.querySelector("#reveal");
    let loader = document.querySelector("#loader-page");
    let logo = document.querySelector("#logo-light");
    let title = document.querySelector("#welcome-title");

    reveal.classList.add("activeBody");

    setTimeout(revealNav, 500);

    function revealNav() {
        logo.classList.add("activeLogo");
        title.classList.add("activeLogo");
        reveal.classList.add("activeNav");
        setTimeout(revealSite, 3200);
    }

    function revealSite() {
        loader.classList.add("activeLoader");
        setTimeout(removeLoader, 400);
    }

    function removeLoader() {
        logo.classList.add("rmvTrans");
        document.querySelector("#reveal").removeAttribute("id");
        document.querySelector("#loader-page").remove();
        window.removeEventListener("load", reveal);
        navMarker();
    }
}

// Logo Lights
window.lights = function () {
    let logo = document.querySelector("#logo-light");
    logo.classList.toggle("on");
};

// Toggle Nav Collapse
window.addEventListener("resize", responsiveNav);

responsiveNav();

function responsiveNav() {
    let nav = document.querySelector("#offcanvasWithBothOptions");
    let navChild = document.querySelector('#scrollspy-collapsible');
    let btn = document.querySelector("#btn-toggle");
    let navH = document.querySelectorAll(
        "#welcome, #projects, #work_experience, #about_me, #contact"
    );

    let wh = $(window).height();
    let ww = $(window).width();

    let mobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );

    if (wh < 840) {
        navH.forEach((nH) => {
            nH.classList.remove("mb-md-5");
        });
    } else {
        navH.forEach((nH) => {
            nH.classList.add("mb-md-5");
        });
    }

    if (wh < 680) {
        navChild.style.overflowY = 'scroll';
        navChild.classList.add('pe-2');
        nav.classList.add('pe-0');
    } else {
        navChild.style.overflowY = 'unset';
        navChild.classList.remove('pe-2');
        nav.classList.remove('pe-0');
    }

    if (ww < 750 || (ww < 900 && mobile)) {
        btn.classList.remove("d-none");
        nav.classList.add("offcanvas");
        nav.classList.add("offcanvas-start");
    } else {
        btn.classList.add("d-none");
        nav.classList.remove("offcanvas");
        nav.classList.remove("offcanvas-start");
        nav.style.visibility = null;
    }
}

window.zoomImg = function (clicked_id) {
    let img = document.querySelector(`#${clicked_id}`);
    img.classList.remove("zoomOut");
    img.classList.add("zoomIn");
    img.classList.remove("mouseZoomIn");
    img.classList.add("mouseZoomOut");

    setTimeout(() => {
        window.addEventListener(
            "click",
            function () {
                removeZoom(img);
            },
            { once: true }
        );
    }, 100);
};

function removeZoom(elem) {
    elem.classList.remove("zoomIn");
    elem.classList.add("zoomOut");
    elem.classList.remove("mouseZoomOut");
    elem.classList.add("mouseZoomIn");
    setTimeout(() => {
        elem.replaceWith(elem.cloneNode(true));
    }, 500);
}

window.scrollToDiv = function (cliked_item) {
    let item = getOffset(document.getElementById(`${cliked_item}`)).top;
    const scrollDiv = document.getElementById('main');

    function getOffset(el) {
        let _y = 0;
        while (el && !isNaN(el.offsetTop)) {
            _y += el.offsetTop + el.scrollTop;
            el = el.offsetParent;
        }
        return {
            top: _y,
        };
    }

    scrollDiv.scrollTo({top: item, behavior: 'smooth'})

}
